<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="1024"
    @click:outside="dialog = false"
  >
    <template #activator="{ props }">
      <v-btn color="orange" append-icon="mdi-pencil-outline" v-bind="props">
        Editar
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <div class="d-flex justify-space-between">
          <span class="text-h5">Editar Fluxo</span>
          <v-btn
            variant="plain"
            rounded="xl"
            prepend-icon="mdi-window-close"
            @click="dialog = false"
          ></v-btn>
        </div>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form ref="form" validate-on="lazy submit">
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-textarea
                  v-model="this.descricao"
                  required
                  label="Descrição*"
                  :rules="descricaoRules"
                ></v-textarea>
              </v-col>

              <v-col v-if="ehPrincipal" cols="12" sm="6">
                <v-select
                  v-model="this.tipoFluxo"
                  label="Tipo Fluxo*"
                  :items="tipoFluxos2"
                  :rules="tipoFluxoRules"
                ></v-select>
              </v-col>

              <v-col v-else cols="12" sm="6">
                <v-select
                  v-model="this.tipoFluxo"
                  label="Tipo Fluxo*"
                  :items="tipoFluxos1"
                  :rules="tipoFluxoRules"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
        <small>*Campo obrigatório</small>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="blue-darken-1" variant="text" @click="submitForm">
          Atualizar
          <v-progress-circular
            v-if="this.isLoading"
            class="ml-2"
            indeterminate
            size="20"
          />
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
/**
 * @module EditFluxo
 * @desc Modal que edita o fluxo.
 * @vue-data {boolean} [dialog=false] - Flag que indica se o diálogo está
 *  aberto ou fechado.
 * @vue-data {string} [descricao=''] - A descrição do fluxo de trabalho.
 * @vue-data {string} [tipoFluxo=''] - O tipo de fluxo de trabalho.
 * @vue-data {boolean} [ehPrincipal=null] - Flag que indica se o fluxo de
 * trabalho é principal ou não, ou null se ainda não estiver definido.
 * @vue-data {Array<string>} [tipoFluxos1=[]] - Uma matriz de strings que
 * representa todos os tipos de fluxos possíveis, exceto o principal.
 * @vue-data {Array<string>} [tipoFluxos2=[]] - Uma matriz de strings que
 * representa o tipo de fluxo de trabalho principal.
 * @vue-data {boolean} [isLoading=false] - Flag que indica se o fluxo ainda
 * está sendo editado.
 */
import axios from 'axios';

import store from '@/store/store';

export default {
  props: {
    id: Number,
  },
  emits: ['fluxoEditado'],
  data: () => ({
    dialog: false,
    descricao: '',
    tipoFluxo: '',
    ehPrincipal: null,
    tipoFluxos1: ['ALTERNATIVO', 'EXCECAO'],
    tipoFluxos2: ['PRINCIPAL'],
    isLoading: false,
    descricaoRules: [(v) => !!v || 'Descrição é obrigatória'],
    tipoFluxoRules: [(v) => !!v || 'Tipo do fluxo é obrigatório'],
  }),
  mounted() {
    this.fetchFluxo(this.id);
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    /**
     * Pega o stakeholder por ID.
     *
     * @param {Number} id O id do projeto.
     */
    async fetchFluxo(id) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(
          `${apiUrl}/api/v1/fluxoCasoUso/${id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );

        this.descricao = response.data.useCase.descricao;
        this.tipoFluxo = response.data.useCase.tipo_fluxo;
        this.ehPrincipal = response.data.useCase.tipo_fluxo === 'PRINCIPAL';
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Envia o formulário.
     */
    async submitForm() {
      const isValid = (await this.$refs.form.validate()).valid;

      if (isValid) {
        const data = {
          descricao: this.descricao,
          // eslint-disable-next-line camelcase
          tipo_fluxo: this.tipoFluxo,
        };
        try {
          this.isLoading = true;
          const apiUrl = process.env.VUE_APP_API_URL;
          const response = await axios.patch(
            `${apiUrl}/api/v1/fluxoCasoUso/${this.id}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            },
          );

          const idCsu = this.$route.params.id;
          const idProjeto = this.$route.params.idProjeto;

          this.$toast.success(response.data.msg);
          this.$emit('fluxoEditado', idCsu);
          this.$router.push(`/projects/${idProjeto}/CasoUso/${idCsu}`);
        } catch (error) {
          console.log(error);
          this.$toast.error(error.response.data.msg);
        } finally {
          this.isLoading = false;
          this.dialog = false;
        }
      }
    },
  },
};
</script>
